import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { ReactComponent as ArrowIcon } from '../../../../../assets/images/common/icons/arrow-right.svg'
import communityMapPreview from '../../../../../assets/images/mock/communityMapPreview.webp'

import classes from './ExploreLocationsCard.module.scss'

const ExploreLocationsCard = () => {
  const { t } = useTranslation()
  const address = useSelector(state => state.studentDashboard.address)

  useEffect(() => {
    localStorage.setItem('communityMapAddress', address)
  }, [address])

  return (
    <Link className={classNames(classes.exploreLocationsCard, 'd-flex align-items-center h-100')} to='/community-map' target='_blank'>
      <img
        className={classNames(classes.mapPreviewImage, 'd-none d-sm-block')}
        src={communityMapPreview}
        alt={t('dashboard.student.exploreLocationsCard.mapPreviewAlt')}
      />

      <section className='align-self-stretch d-flex flex-column justify-content-start ml-0 ml-sm-4 mr-4'>
        <h4 className={classNames(classes.title, 'mt-3')}>{t('dashboard.student.exploreLocationsCard.title')}</h4>

        <small className={classNames(classes.subtitle, 'mt-3')}>{t('dashboard.student.exploreLocationsCard.subtitle')}</small>
      </section>

      <ArrowIcon className={classNames(classes.arrowIcon, 'ml-auto')} />
    </Link>
  )
}

export default ExploreLocationsCard
